export const TOKEN_CREATION_TIME = 'tokenCreationTime';
export const OAUTH2_TOKEN = 'oauth2Token';
export const GCS_OAUTH_TOKEN = 'gcsOauthToken';
export const DRIVE_LABELS_OAUTH_TOKEN = 'driveLabelsOauthToken';
export const MS_GRAPH_TOKEN = 'msGraphToken';
export const SCOPES = 'scopes';

export const PENDING_OAUTH_RETURN_URL = 'pendingOauthReturnUrl';
export const PENDING_OAUTH_SCOPES = 'pendingOauthScopes';
export const PENDING_OAUTH_TOKEN_KEY = 'pendingOauthTokenKey';
export const PENDING_DRIVE_LABEL_CREATION = 'pendingDriveLabelCreation';
